import CONSTANTS from "./constants";
// INITITALSTATE
const initialState = {
  allowScroll: true,
  heading: "",
  userDetailsInfo: {},
  isPullToRefreshOpen: false,
  isPullToRefreshReleased: false,
  showSuggestions: true,
  isBuyNowDoubtBuddyModalOpen: false,
};

// FUNCTIONS
const setHeading = (value) => {
  return {
    heading: value,
  };
};

const toggleScroll = (value) => {
  return {
    allowScroll: value,
  };
};

const togglePullToRefresh = (value) => {
  return {
    isPullToRefreshOpen: value,
  };
};
const togglePullToRefreshRelease = (value) => {
  return {
    isPullToRefreshReleased: value,
  };
};

const setShowSuggestions = (value) => {
  return {
    showSuggestions: value,
  };
};

const setShowBuyNowDoubtBuddyModal = (value) => {
  return {
    isBuyNowDoubtBuddyModalOpen: value,
  };
}
const setUserDetailsInfo = (value) => {
  return {
    userDetailsInfo: value,
  };
};
// REDUCER
const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.LAYOUT_PAGE_HEADING:
      return {
        ...state,
        ...setHeading(action.payload),
      };
    case CONSTANTS.LAYOUT_SCROLL_TOGGLE:
      return {
        ...state,
        ...toggleScroll(action.payload),
      };
    case CONSTANTS.LAYOUT_PULL_DOWN_REFRESH:
      return {
        ...state,
        ...togglePullToRefresh(action.payload),
      };
    case CONSTANTS.LAYOUT_PULL_DOWN_REFRESH_RELEASE:
      return {
        ...state,
        ...togglePullToRefreshRelease(action.payload),
      };
    case CONSTANTS.LAYOUT_SHOW_SUGGESTIONS:
      return {
        ...state,
        ...setShowSuggestions(action?.payload),
      };
    case CONSTANTS.LAYOUT_USER_DETAILS_INFO:
      return {
        ...state,
        ...setUserDetailsInfo(action?.payload || {}),
      };
    case CONSTANTS.BUYNOW_DOUBT_BUDDY_MODAL:
      return {
        ...state,
        ...setShowBuyNowDoubtBuddyModal(action?.payload),
      };
    default:
      return state;
  }
};

export default layoutReducer;
